module.exports = __webpack_public_path__ + "static/img/jusang.899db0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/jusang.png
// module id = 0HEl
// module chunks = 1